import { bdbToUint8Array, isBchqTemplate, isBchiTemplate } from './bdbUtils';
import { extractNistFaceTemplates } from './nistFaceMatch';
import { extractNistIrisTemplates } from './nistIrisMatch';

/** Plain images for NIST extract (includes FRVT validation formats). */
export const NIST_PLAIN_IMAGE_EXTS = new Set(['jpeg', 'jpg', 'bmp', 'png', 'ppm', 'pgm']);

export function isPlainImageFile(file) {
  const ext = file?.name?.split('.').pop()?.toLowerCase();
  return NIST_PLAIN_IMAGE_EXTS.has(ext);
}

export function isNistPlainImageExtension(ext) {
  return NIST_PLAIN_IMAGE_EXTS.has(String(ext || '').toLowerCase().replace(/^\./, ''));
}

export async function resolveFaceGalleryBdb(biosdkBaseUrl, file, scenario = 'single') {
  if (isPlainImageFile(file)) {
    const extracted = await extractNistFaceTemplates(biosdkBaseUrl, [file], scenario);
    const bdb = extracted.templates[0]?.bdbBytes;
    if (!bdb || !isBchqTemplate(bdb)) {
      throw new Error(`Gallery image ${file.name} did not produce BCHQ.`);
    }
    return bdb;
  }
  const buf = bdbToUint8Array(await file.arrayBuffer());
  if (!isBchqTemplate(buf)) {
    throw new Error(`Gallery file ${file.name} is not BCHQ.`);
  }
  return buf;
}

export async function resolveIrisGalleryBdb(biosdkBaseUrl, file, scenario = 'single', irisSubtype = 'Left') {
  if (isPlainImageFile(file)) {
    const extracted = await extractNistIrisTemplates(biosdkBaseUrl, [file], scenario, irisSubtype);
    const bdb = extracted.templates[0]?.bdbBytes;
    if (!bdb?.length) {
      throw new Error(`Gallery image ${file.name} did not produce iris template.`);
    }
    return bdb;
  }
  const buf = bdbToUint8Array(await file.arrayBuffer());
  if (!buf.length) {
    throw new Error(`Gallery file ${file.name} is empty.`);
  }
  return buf;
}
